import React, { useState } from "react";

import Box from "./base/box";
import Flex from "./base/flex";
import Link from "./base/link";
import { lightBlue, deepBlue, white, transparentGray } from "./base/colors";

import ExpandButton from "./expand-button";

import useGetBrowserSize from "../hooks/use-is-mobile";
import { useContentContext } from "../context/content-context";

const variants = {
  footer: "footer",
  navigation: "navigation",
  mobileNavigation: "mobileNavigation",
};

const NavigationDropdown = ({ variant, title, children }) => {
  const [isDropdownExpanded, setIsDropdownExpanded] = useState(false);
  const { isHCP } = useContentContext();

  const isFooter = variant === variants.footer;

  // TODO: theres got to be a better way to organize this lol
  const VARIANT_STYLES = {
    footer: {
      variant: isHCP ? "navigationBlueNoHover" : "navigationWhiteNoHover",
      width: isHCP
        ? ["unset", "182px", "unset"]
        : ["unset", "calc(50% - 12px)", "unset"],
      marginBottom: isHCP ? [0, 0, "30px"] : [0, "30px", "30px"],
    },
    navigation: {
      variant: isHCP ? "navigationBlue" : "navigationWhite",
      marginLeft: isHCP ? "20px" : "24px",
      minWidth: "103px",
      maxWidth: isHCP ? "155px" : "unset",
    },
    mobileNavigation: {
      variant: isHCP ? "navigationWhite" : "navigationBlue",
      marginLeft: 0,
    },
  };
  const isMainNav = variant !== variants.footer;
  const { isDesktop } = useGetBrowserSize();

  const isIndication = title === "Select an Indication" && isDesktop;

  return (
    <Box
      position="relative"
      onMouseEnter={() => {
        isMainNav && setIsDropdownExpanded(true);
      }}
      onMouseLeave={() => {
        setIsDropdownExpanded(false);
      }}
      width={VARIANT_STYLES[variant].width}
      maxWidth={VARIANT_STYLES[variant].maxWidth}
      mb={VARIANT_STYLES[variant].marginBottom}
    >
      <Flex
        width="fit-content"
        alignItems="center"
        mb={isFooter ? ["10px", "5px", "5px"] : ["18px", "18px", "0"]}
      >
        <Link
          as="div"
          textAlign="left"
          background="none"
          border="none"
          mr={0}
          mb={[0, 0, 0]}
          padding={0}
          flexGrow={[1, 1, 0]}
          width="fit-content"
          variant={VARIANT_STYLES[variant].variant}
          ml={VARIANT_STYLES[variant].marginLeft}
        >
          {title}
        </Link>
        {(isIndication || (!isDesktop && isMainNav)) && (
          <ExpandButton
            color={isIndication ? deepBlue : isHCP ? white : deepBlue}
            isExpanded={isDropdownExpanded}
            isIndication={isIndication}
            isDesktop={isDesktop}
            setIsExpanded={setIsDropdownExpanded}
          />
        )}
      </Flex>
      {isDropdownExpanded && (
        <Flex
          position={["relative", "relative", "absolute"]}
          top="100%"
          left={0}
          backgroundColor={["transparent", "transparent", "white"]}
          flexDirection="column"
          padding={["0 0 10px 29px", "0 0 10px 29px ", "10px 7px 2px"]}
          ml={isHCP ? [0, 0, "18px"] : [0, 0, "24px"]}
          borderTop={["none", "none", `2px solid ${lightBlue}`]}
          boxShadow={["none", "none", `0px 3px 6px ${transparentGray}`]}
          width="calc(100% - 24px)"
          minWidth="135px"
        >
          {children}
        </Flex>
      )}
      {!isMainNav && children}
    </Box>
  );
};

export default NavigationDropdown;
